export default __webpack_public_path__ + "static/media/sv_6.92cd9757.webp";